import { supabase } from '@/integrations/supabase/client';

/**
 * Checks if a user account is active
 * Returns true by default if check fails (fail-open for better UX)
 */
export async function checkUserIsActive(userId: string): Promise<boolean> {
  try {
    const { data: profile, error } = await supabase
      .from('profiles')
      .select('is_active')
      .eq('id', userId)
      .single();

    if (error) {
      console.error('Error checking user status:', error);
      return true; // Default to active on error
    }

    return profile?.is_active ?? true;
  } catch (error) {
    console.error('Unexpected error checking user status:', error);
    return true;
  }
}

/**
 * Gets the full redirect URL for auth callbacks
 */
export function getRedirectUrl(path: string = '/'): string {
  return `${window.location.origin}${path}`;
}
